import { render } from "./RepairConsole.vue?vue&type=template&id=3af5674b"
import script from "./RepairConsole.vue?vue&type=script&lang=js"
export * from "./RepairConsole.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/roshdfarms-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__